import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

//

// export const RowWrapperMui = styled(Stack)(() => ({
//   direction: { sm: "row", xs: "column" },
// }));

export const RowWrapperMui = ({ children }) => (
  <Stack direction={{ sm: "row", xs: "column" }} spacing={2}>
    {children}
  </Stack>
);
